var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.66669V21.3334C11.5 32.1107 23.1666 38.8463 32.5001 33.4576C36.8317 30.957 39.5 26.3351 39.5 21.3334V2.66669H11.5Z",
    stroke: "currentColor",
    strokeWidth: 3.41271
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8333 21.3334V2.66669H2.16663V21.3334",
    stroke: "currentColor",
    strokeWidth: 3.41271
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 49.3333H37.1668",
    stroke: "currentColor",
    strokeWidth: 3.41271
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 35.3333V49.3333",
    stroke: "currentColor",
    strokeWidth: 3.41271
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.6039f240.svg";
export { ForwardRef as ReactComponent };